// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__qazxR","form":"styles_form__2pnNv"};